import React from "react";
import {
  Box, CircularProgress, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton, Chip
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const TYPE_COLOR = {
  service: "info",
  management: "secondary",
  accountant: "warning",
  sales: "success",
  support: "primary",
  other: "default",
};

export default function ContactsTable({ rows, loading, onEdit, onDelete, busyId, query, typeFilter }) {
  const { t } = useTranslation();

  // client-side filtering
  const q = (query || "").trim().toLowerCase();
  const filtered = rows.filter((r) => {
    const matchesType = !typeFilter || r.type === typeFilter;
    if (!q) return matchesType;
    const hay = `${r.first_name || ""} ${r.last_name || ""} ${r.email || ""} ${r.phone || ""}`.toLowerCase();
    return matchesType && hay.includes(q);
  });

  const typeLabel = (type) =>
    t(`contactsTable.types.${type}`, type);

  if (loading) {
    return (
      <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell width={140}>{t("contactsTable.columns.type", "Type")}</TableCell>
            <TableCell>{t("contactsTable.columns.name", "Name")}</TableCell>
            <TableCell>{t("contactsTable.columns.email", "Email")}</TableCell>
            <TableCell>{t("contactsTable.columns.phone", "Phone")}</TableCell>
            <TableCell align="right" width={120}>
              {t("contactsTable.columns.actions", "Actions")}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filtered.length === 0 && (
            <TableRow>
              <TableCell colSpan={5}>
                <Box sx={{ p: 2, textAlign: "center", color: "text.secondary" }}>
                  {t("contactsTable.empty", "No contacts match your filters.")}
                </Box>
              </TableCell>
            </TableRow>
          )}

          {filtered.map((r) => (
            <TableRow key={r.id} hover>
              <TableCell>
                <Chip
                  variant="outlined"
                  size="small"
                  color={TYPE_COLOR[r.type] || "default"}
                  label={typeLabel(r.type)}
                />
              </TableCell>

              <TableCell>
                {r.first_name} {r.last_name}
              </TableCell>

              <TableCell>{r.email || "—"}</TableCell>
              <TableCell>{r.phone || "—"}</TableCell>

              <TableCell align="right">
                <IconButton
                  size="small"
                  onClick={() => onEdit(r)}
                  aria-label={t("contactsTable.actions.edit", "Edit")}
                >
                  <Edit fontSize="small" />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={() => onDelete(r)}
                  disabled={busyId === r.id}
                  aria-label={t("contactsTable.actions.delete", "Delete")}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
